import { isMobile } from '../utils/helper';
import { getWidgetHeight, getWidgetHeightDesktop } from '../utils/helper';

export { cardEmiLenders } from './cardEmiLenderInfo';
export {
  cancellationReasons,
  otpPageCancellationReasons,
} from './transactionCancellationReasons';
export { testimonialContent } from './testimoials';
export {
  commonVouchersData,
  noCostsOffersData,
  zebrsData,
  nilkamalData,
  mdComputersData,
  lotMobilesData,
  bigCData,
  doctorDreamsData,
  sleepyheadData,
  pepperfryData,
  sangeethaMobilesData,
} from './offersDetails';

export const overLayHeights = {
  checkEligibleWidgetHeight: isMobile
    ? getWidgetHeight(80)
    : getWidgetHeightDesktop(),
  emiInfoHeight: isMobile ? getWidgetHeight(80) : getWidgetHeightDesktop(),
};
export { navMenuList } from './navMenuList';

export const iciciLenderId = 701;

export const NTB_PLAYSTORE_LINK =
  'https://play.google.com/store/apps/details?id=me.instacred.instantemi';



// WEBPACK FOOTER //
// ./constants/index.js